import store from "./store.js";

export default class PersonalDataStore {
  constructor() {
    this.firstName = null;
    this.lastName = null;
    this.mail = null;
    this.phone = null;
    this.education = null;
  }
  setFirstName(firstName) {
    if (store.isLocalStorage()) {
      localStorage.setItem("firstName", firstName);
    }
    this.firstName = firstName;
  }
  getFirstName() {
    if (store.isLocalStorage()) {
      return localStorage.getItem("firstName");
    }
    return this.firstName;
  }
  setLastName(lastName) {
    if (store.isLocalStorage()) {
      localStorage.setItem("lastName", lastName);
    }
    this.lastName = lastName;
  }
  getLastName() {
    if (store.isLocalStorage()) {
      return localStorage.getItem("lastName");
    }
    return this.lastName;
  }
  setMail(mail) {
    if (store.isLocalStorage()) {
      localStorage.setItem("mail", mail);
    }
    this.mail = mail;
  }
  getMail() {
    if (store.isLocalStorage()) {
      return localStorage.getItem("mail");
    }
    return this.mail;
  }
  setPhone(phone) {
    if (store.isLocalStorage()) {
      localStorage.setItem("phone", phone);
    }
    this.phone = phone;
  }
  getPhone() {
    if (store.isLocalStorage()) {
      return localStorage.getItem("phone");
    }
    return this.phone;
  }
  setEducation(education) {
    if (store.isLocalStorage()) {
      localStorage.setItem("education", education);
    }
    this.education = education;
  }
  getEducation() {
    if (store.isLocalStorage()) {
      return localStorage.getItem("education");
    }
    return this.education;
  }
}
